
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.056 8.674l6.756-6.401a1.001 1.001 0 011.376 1.452L15.74 9.833l4.074 2.804c.274.189.457.39.565.593a.937.937 0 01.073.753c-.07.219-.218.412-.422.573-.266.21-.64.372-1.064.46l-.015.003-3.02.628 2.152 3.769a.85.85 0 01.079.643.9.9 0 01-.378.522c-.007.006-.016.01-.024.015l-2.235 1.297a.897.897 0 01-.653.078.848.848 0 01-.517-.391l-2.168-3.757-2.062 2.326c-.287.324-.613.568-.928.696a1.209 1.209 0 01-.705.082.94.94 0 01-.612-.441c-.123-.195-.204-.456-.229-.79l-.157-2.051-4.306 4.08a1 1 0 11-1.376-1.452l5.486-5.197-.796-10.43C6.5 4.635 6.5 4.623 6.5 4.613a.636.636 0 01.254-.519.34.34 0 01.122-.06c.086-.029.175-.039.261-.029a.609.609 0 01.239.076.379.379 0 01.071.044l6.609 4.549zm1.102 1.711l-6.93 6.566.205 2.688c.015.199.054.34.11.428.032.051.071.08.112.089a.444.444 0 00.251-.041c.202-.082.425-.253.633-.489l2.422-2.732a.39.39 0 01.631.064l2.44 4.226a.066.066 0 00.041.025.107.107 0 00.064-.001c.007-.004.015-.009.023-.012h.001l.168-.039a.38.38 0 00-.162.035l-.006.004h-.002l.008-.004 2.199-1.276a.113.113 0 00.041-.06.084.084 0 00-.001-.048l-2.422-4.24h.002a.393.393 0 01.26-.581l3.549-.739.015-.002c.306-.065.565-.173.739-.31a.455.455 0 00.161-.197c.014-.04.008-.088-.021-.142-.05-.094-.15-.197-.314-.31l-4.217-2.902zm-7.127 3.997l5.442-5.156-6.16-4.238.718 9.394z","fill-rule":"nonzero"}})])
          )
        }
      }
    